import { useState } from "react";
import { Popover } from "web-ui";

import type { AppStoreReleaseStatus } from "api/dashboardBackend";
import styles from "components/dashboard/release-card/per-app-store-release-status/ReleaseStatusIcon.module.scss";
import strings from "components/dashboard/release-card/per-app-store-release-status/ReleaseStatusIcon.strings.json";
import { linksToAppStoreMap } from "components/dashboard/release-card/per-app-store-release-status/linksToAppStoreMap";

// Icons are labelled with the store's initial, so Honor uses R (Rongyao, its Chinese
// brand name) to stay one character wide without colliding with Huawei's H.
const appStoreIconLabels: Record<string, string> = {
  ["honor"]: "R",
};

interface Props {
  appStoreReleaseStatus: AppStoreReleaseStatus;
}

const ReleaseStatusIcon = ({ appStoreReleaseStatus }: Props) => {
  const [appStorePopover, setShowAppStorePopover] = useState<string | null>(
    null,
  );

  const appStore = appStoreReleaseStatus.app_store.toLowerCase();
  const iconLabel =
    appStoreIconLabels[appStore] ?? appStoreReleaseStatus.app_store.charAt(0);

  const tencentInfo = (
    <div className={styles.tencentInfo}>{strings.tencent_info}</div>
  );

  return (
    <>
      <a
        className={styles.icon}
        href={linksToAppStoreMap[appStore]}
        onMouseEnter={() =>
          setShowAppStorePopover(appStoreReleaseStatus.app_store)
        }
        onMouseLeave={() => setShowAppStorePopover(null)}
        rel="noopener noreferrer"
        style={{ backgroundColor: appStoreReleaseStatus.color }}
        target="_blank"
      >
        <div className={styles.centerIcon}>{iconLabel}</div>
      </a>
      {appStorePopover && (
        <Popover direction="down" zIndex={100}>
          <div className={styles.popoverContent}>
            <div
              className={styles.popoverTitle}
            >{`${appStoreReleaseStatus.app_store}: `}</div>
            <div style={{ color: appStoreReleaseStatus.color }}>
              {appStoreReleaseStatus.status in strings
                ? strings[appStoreReleaseStatus.status as keyof typeof strings]
                : appStoreReleaseStatus.status}
            </div>
            {appStore === "tencent" && tencentInfo}
          </div>
        </Popover>
      )}
    </>
  );
};

export default ReleaseStatusIcon;
